<div class="mat-typography">
    <table>
        <tr>
            <th>
                Field
            </th>

            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>

        <tr>
            <td>
                <div class="item">

                    Configure App Consent Permissions
                    <mat-icon
                        matTooltip="Configure whether users are allowed to consent for applications to access your organization's data.">info</mat-icon>

                </div>
            </td>

            <td>
                <div class="validator">
                    <div>
                        {{getValue(data.permissionGrantPolicyIdsAssignedToDefaultUserRole)?.value}}
                    </div>

                    <div class="text-gray-500">
                        {{getValue(data.permissionGrantPolicyIdsAssignedToDefaultUserRole)?.hint}}
                    </div>
                </div>
            </td>

            <td class="desired-value">
                <div class="field boolean">
                    <mat-form-field appearance="fill">
                        <mat-label>Status</mat-label>
                        <mat-select [formControl]="control">
                            <mat-option [value]="'noUsers'">
                                Do not allow user consent

                                <div class="text-gray-500">
                                    An administrator will be required for all apps.
                                </div>
                            </mat-option>

                            <mat-option [value]="'verifiedUsers'">
                                Allow user consent for apps from verified publishers, for selected permissions
                                (Recommended)
                                <div class="text-gray-500">
                                    All users can consent for permissions classified as "low impact", for apps from
                                    verified publishers or apps registered in this organization.
                                </div>
                            </mat-option>

                            <mat-option [value]="'allUsers'">
                                Allow user consent for apps
                                <div class="text-gray-500">
                                    All users can consent for any app to access the organization's data.
                                </div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </td>

            <td>
                <sway-baseline-status [errors]="errors"></sway-baseline-status>
            </td>
        </tr>
    </table>
</div>
